<template>
<v-menu v-model="menuFuncType" offset-y lazy :close-on-content-click="false">
  <template v-slot:activator="{ on }">
    <v-btn flat v-on="on" style="min-width:24px;">
      <v-icon v-if="available">lightbulb</v-icon>
      <v-icon v-else>lightbulb_outline</v-icon>
    </v-btn>
  </template>
  <functype-selector solo v-model="$root.searchFuncType" :label="$t('device.filter_by_functype')" clearable style="max-width:280px"></functype-selector>
</v-menu>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import FuncTypeSelector from '@/components/device/FuncTypeSelector'

export default {
  name: 'SearchFuncTypeMenu',
  mixins: [UserAuth],
  components: {
    'functype-selector': FuncTypeSelector
  },
  data() {
    return {
      menuFuncType: false,
    }
  },
  computed: {
    available() {
      return !!this.$root.searchFuncType;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/SearchFuncTypeMenu.vue